export const smallImage =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_auto/v1/attachments/generic_asset/asset/1438694386764e2f456fdec982774641-1574244345203/objects%20%28small%29.png';
export const defaultImage =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_auto/v1/attachments/generic_asset/asset/aefc93b7dbd5f22ac8f393eef9e0e551-1574599218756/objects%20%28xl%29%20%284%29.png';
